import { useQuery } from "react-query";
import axios from "infra/http";
import {GetEncargosResponse} from '../typings';

function useFindEncargos(dataVencimento?: string, dataCalculo?: string, valor?: number, enabled?: boolean) {
  return useQuery(
    [`/v1/conta/encargos`, dataCalculo],
    async () => {
      const { data } = await axios.get<GetEncargosResponse>(`/v1/conta/encargos`, {
        params: {
          dataCalculo,
          dataVencimento,
          valor,
        }
      });

      return data;
    },
    {
      enabled: !!dataVencimento && !!valor && enabled,
    }
  );
}

export default useFindEncargos;
